import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.min.js';
import { ChakraProvider } from '@chakra-ui/react';
import { Route, Routes, BrowserRouter, Navigate } from "react-router-dom";
import ErrorPage from "./main/components/ErrorPage";
import Login from "./main/components/mainComponents/Login";
import Main from './main/components/mainComponents/Main';
import Analytics from "./main/components/mainComponents/Analytics";
import AllUsersTable from "./main/components/tableComponents/tables/AllUsersTable";
import RequestingUsers from "./main/components/tableComponents/tables/RequestingUsers";
import AdsManager from "./main/components/tableComponents/tables/AdsManager";
import PaymentHistory from "./main/components/tableComponents/tables/PaymentHistory";

// A "Guard" component to protect your routes
const ProtectedRoute = ({ children }) => {
    const isLogged = localStorage.getItem('AdminToken');
    // If not logged in, send them to login, but remember where they wanted to go
    return isLogged ? children : <Navigate to="/login" replace />;
};

export default function App() {
    return (
        <ChakraProvider>
            <BrowserRouter>
                <Routes>
                    {/* Public Route */}
                    <Route path="/login" element={<Login />} />

                    {/* Protected Routes */}
                    {/* Main acts as the Layout wrapper */}
                    <Route path="/" element={<ProtectedRoute><Main /></ProtectedRoute>}>
                        {/* Default view when entering / */}
                        <Route index element={<Analytics />} />

                        {/* Sub-routes that load inside Main */}
                        <Route path="users" element={<AllUsersTable />} />
                        <Route path="requests" element={<RequestingUsers />} />
                        <Route path="payments-history" element={<PaymentHistory />} />
                        <Route path="ads" element={<AdsManager />} />
                        <Route path="analytics" element={<Analytics />} />
                    </Route>

                    {/* 404 Route */}
                    <Route path="*" element={<ErrorPage />} />
                </Routes>
            </BrowserRouter>
        </ChakraProvider>
    );
}